<template>
  <div class="">
    <div v-if="idenCode == 1">
      <introduceVue />
      <information />
      <missionVue />
      <CertificationVue />
    </div>
    <div v-if="idenCode == 3">
      <informationIndex />
    </div>
  </div>
</template>

<script>
import introduceVue from "./introduce.vue";
import information from "./information.vue";
import missionVue from "./mission.vue";
import CertificationVue from "./Certification.vue";
import informationIndex from "@/components/information/index.vue";
export default {
  props: ["idenCode"],
  components: {
    introduceVue,
    information,
    missionVue,
    CertificationVue,
    informationIndex,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped></style>
